import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { modalFn, UiCoreModule } from '@softline/ui-core';
import { FilterAndSortDialog } from '../../dialogs/filter-and-sort/filter-and-sort.dialog';
import { FilterConfig } from '../../types/filter-config';
import { SortConfig } from '../../types/sort-config';
import { SearchInputComponent } from '../search-input/search-input.component';
import { Explorer, FilterExplorer, SearchExplorer, SortExplorer } from '@softline/core';

@Component({
    selector: 'soft-filter-and-sort',
  imports: [CommonModule, UiCoreModule, SearchInputComponent],
    templateUrl: './filter-and-sort.component.html',
    styleUrls: ['./filter-and-sort.component.scss']
})
export class FilterAndSortComponent<T extends object> {
  private readonly modal = modalFn();
  readonly explorer = input.required<Explorer<T> & FilterExplorer<T> & SortExplorer<T> & SearchExplorer<T>>();

  readonly filterConfig = input<FilterConfig | null | undefined>();
  readonly sortConfig = input<SortConfig | null | undefined>();

  async onOpenDialog(): Promise<void> {
    const result = await this.modal({
      component: FilterAndSortDialog,
      data: {
        filterConfig: this.filterConfig(),
        sortConfig: this.sortConfig(),
        items: this.explorer().source,
        filters: this.explorer().filterParams(),
        sort: this.explorer().sortParams()
      }
    })
    if(result === 'DISMISSED')
      return;
    this.explorer().filter(result.filter ?? []);
    this.explorer().sort(result.sort as any);
  }
}
